module.exports = __webpack_public_path__ + "assets/96c3df409d122ee5e0818811cd4f8c46.mp3";